export default {
    name : 'header',
    init()
    {
        this.run();
    },
    run ()
    {
        this.handleScrollStatus();
        window.addEventListener('scroll', this.handleScrollStatus);
        this.initMenu();
        this.initMobileMenu();
    },
    handleScrollStatus ()
    {
        const currentScrollY  = window.scrollY;
        const header = document.querySelector('#header');

        if (currentScrollY < 100) {
            header.classList.remove('scrolled');
        } else {
            header.classList.add('scrolled');
        }
    },
    initMenu()
    {
        const elements = document.querySelectorAll('.toggle-mobile-menu');

        elements.forEach((btn) => btn.addEventListener('click', function(){
            document.getElementById('mobileMenuLayer').classList.toggle('active');
        }) );
    },
    initMobileMenu()
    {
        const elements = document.querySelectorAll('.mobile-parent-link');

        elements.forEach((btn) => btn.addEventListener('click', function(event) {
            this.closest('.with-children').classList.toggle('active');
        }) );
    }

}